module.exports = __webpack_public_path__ + "img/cod-logo-3.bd1bbf3c.svg";